module.exports = __webpack_public_path__ + "static/media/cert_7.13803ae3.jpg";